const Actions = {
  GET_SETTINGS_DATA: "GET_SETTINGS_DATA",
  GET_SETTINGS_DATA_SUCCESS: "GET_SETTINGS_DATA_SUCCESS",
  GET_SETTINGS_DATA_FAIL: "GET_SETTINGS_DATA_FAIL",
};

export default Actions;
